import styles from "./HorizontalRule.module.scss";

export function HorizontalRule() {
  return <hr className={styles.hr} />;
}
